export default "__VITE_ASSET__BfT7_GOt__"